module.exports = __webpack_public_path__ + "static/media/oct28-17.013335ae.png";